import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FaqList({ items }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((it, i) => (
        <AccordionItem
          key={it.q}
          value={`i${i}`}
          className="reveal border-b border-neutral-200"
        >
          <AccordionTrigger className="font-head py-5 text-left text-[17px] font-bold text-[#244aa2] hover:text-[#a10000] hover:no-underline">
            {it.q}
          </AccordionTrigger>
          <AccordionContent className="pb-6 text-[15px] leading-relaxed text-[#575757]">
            {it.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
